import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbAccountPermissionApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'db-accountpermission';
    }

    /**
     * 获取全部数据
     */
    public async getListAll() {
        return await this.send({}, 'getListAll', Methods.GET);
    }

    public async getDbFor2(accountId: number) {
        return await this.send({ accountId }, 'getDbFor2', Methods.GET);
    }

    public async getDbInfo(accountId: number) {
        return await this.send({ accountId }, 'getDbInfo', Methods.GET);
    }

    public async updateDb(datas) {
        return await this.send(datas, 'updateDb', Methods.POST);
    }

    public async getDbRoleMap(accountId: number) {
        return await this.send({ accountId }, 'getDbRoleMap', Methods.GET);
    }

    public async saveDbRole(datas) {
        return await this.send(datas, 'saveDbRole', Methods.POST);
    }

}